import PortalHeader from "./PortalHeader";
import usePortalTheme from "../../hooks/usePortalTheme";
import { StarIconContext } from "../StarIcon/StarIcon";
import { GlobalDisplayContext } from "./GlobalDisplayContext";
import getCornerRadiusStyle from "../../utils/cornerRadius";
import "../../assets/scss/portal.scss";

// Full-height page: header on top, scrollable content below. Every page (guest,
// login, logged-in) renders inside it, so the shop's widget colors and global
// display settings (star icon, button / element corners) apply everywhere.
const PortalShell = ({ children, globalDisplay = null, ...headerProps }) => {
    const themeStyle = usePortalTheme();
    return (
        <GlobalDisplayContext.Provider value={globalDisplay}>
            <StarIconContext.Provider value={globalDisplay?.star_icon?.html || null}>
                <div
                    className="portal"
                    style={{ ...themeStyle, ...getCornerRadiusStyle(globalDisplay) }}
                >
                    <PortalHeader {...headerProps} />
                    <main className="portal__main">{children}</main>
                </div>
            </StarIconContext.Provider>
        </GlobalDisplayContext.Provider>
    );
};

export default PortalShell;
